import MapIcon from '@material-ui/icons/Map'
import Map from './Map';

export default {
  map: Map,
  icon: MapIcon,
}
